import api from "@/configs/axios-config";

export type LogActivity = {
  id: number;
  resource: string;
  entity: string;
  entity_id: string;
  action: string;
  performed_by: string;
  email?: string;
  role?: string;
  time_stamp: string;
};

export type LogActivityDetail = {
  id: number;
  resource: string;
  entity: string;
  entity_id: string;
  action: string;
  performed_by: string;
  time_stamp: string;
  old_values: string;
  new_values: string;
  remark: string;
};

export type LogActivityParams = {
  performed_by?: string;
  search_date?: string;
  resource?: string;
  entity?: string;
  only_system?: boolean;
  action?: string;
  skip?: number;
  limit?: number;
};

export const getLogActivities = async (
  params: LogActivityParams,
): Promise<{ data: LogActivity[]; total: number }> => {
  const res = await api.get("/audit-logs/", { params });
  return res.data;
};

export const getLogActivityDetail = async (
  id: number,
): Promise<LogActivityDetail> => {
  const res = await api.get(`/audit-logs/details/${id}`);
  return res.data;
};

export type LogStatic = {
  all_log_count: number;
  create_log_count: number;
  update_log_count: number;
  delete_log_count: number;
  login_log_count: number;
  unique_user_count: number;
};

export const getLogStatic = async (searchDate: string): Promise<LogStatic> => {
  const res = await api.get("/audit-logs/statistics", {
    params: { search_date: searchDate },
  });
  return res.data;
};

export type ResourceEntity = {
  resource: string;
  display_name: string;
};

export const getResourceEntity = async (): Promise<ResourceEntity[]> => {
  const res = await api.get("/audit-logs/resources");
  return res.data;
};

export type Entity = {
  id: number;
  resource: string;
  entity: string;
};

export const getEntities = async (): Promise<Entity[]> => {
  const res = await api.get("/audit-logs/entities");
  return res.data;
};

export const login = async () => {
  await api.post("/audit-logs/login");
}